// extracted by mini-css-extract-plugin
export default {"discover":"styles_discover__uK1jx","discover__arrow":"styles_discover__arrow__Rrr8W","rotation":"styles_rotation__C--DU"};